<template>
  <!-- div class="uk-grid program-details-grid" -->
  <div style="padding: 0;margin: 0;">

    <div class="uk-grid uk-grid-small uk-animation-slide-top-small" style="max-width: 1140px; margin: auto; padding: 0 0 5px 0;">

      <div class="uk-width-1-6@m" style="padding: 5px;">
        <div @click="to_all_airdates(air_data)" v-if="$route.params.exact_match !== '1'" class="button-schedule button-float-xs button-float-m-margin">all airdates</div>
        <div @click="(reminder_data == null) ? reminder_data = air_data.program_details: reminder_data = null" class="button-schedule button-float-xs">remind me</div>

        <!-- ul class="pd-program-info" style="margin-top: 0px;margin-top: 30px;">
          <li class="pd-program-info-first">{{air_data.program_details.total_mins}} minutes</li>
          <li class="pd-program-info-first" v-if="air_data.program_details.episode_num.length > 0 && air_data.program_details.episode_num > 0">episode #{{air_data.program_details.episode_num}}</li>
          <li v-if="air_data.program_details.episode_num.series_url != undefined"><a href="air_data.program_details.episode_num.series_url" target="_blank">program's official website</a></li>
          <li v-if="air_data.program_details.episode_num.episode_url != undefined"><a href="air_data.program_details.episode_num.episode_url" target="_blank">program's official website</a></li>
        </ul -->
      </div>

      <div :class="`${(air_data.program_details.have_image || air_data.program_details.display_option == 9) ? 'uk-width-1-2@m':'uk-width-5-6@m'}`" style="padding: 5px 10px;">
        <div class="pbs-schedule-synopsis" v-html="details_description(air_data.program_details)" v-if="details_description(air_data.program_details).length > 1"></div>
        <!-- ====={{details_description(air_data.program_details)}}======= -->
        <!--margin-top: -12px;
        padding: 0px 10px;-->
        <div :style="`font-size: 18px; font-family: Avenir-medium;${(details_description(air_data.program_details).length > 1)?'margin-top: 20px;':''}`">{{air_data.program_details.total_mins}} minutes
          <span v-if="air_data.program_details.episode_num.length > 0 && air_data.program_details.episode_num > 0">
            <span style="font-family: Avenir-light; color: #00000044;">&nbsp; &vert;</span> &nbsp; episode #{{air_data.program_details.episode_num}}
          </span>
          <!-- span v-if="air_data.program_details.genre_list.length > 0 && air_data.program_details.genre_list !== ''">
            <span style="font-family: Avenir-light; color: #00000044;">&nbsp; &vert;</span> &nbsp; {{air_data.program_details.genre_list}}
          </span -->
        </div>
      </div>
      <div v-if="air_data.program_details.have_image || air_data.program_details.display_option == 9" class="uk-width-1-3@m" style="padding: 5px;">
        <div style="background: #92a49a; width: 100%;text-align: center;"  v-if="air_data.program_details.have_image && air_data.program_details.display_option != 9">
          <img :src="`${base_url}${(air_data.program_details.i_file_path == null) ? air_data.program_details.is_file_path:air_data.program_details.i_file_path}${air_data.program_details.image_src}`" style="width: 100%"/>
        </div>
        <div style="background: #92a49a; width: 100%; text-align: center;" v-if="air_data.program_details.display_option == 9">
          <a target="_blank" v-if="is_passport_full_length(air_data)" :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.passport.asset_slug}/`">
            <div class="container"  :style="`background-image: url(${air_data.program_details.media_manager_data.passport.image_url_1}); background-size: 100% 100%; position: relative; width: 100%; padding-top: 56.25%;`" >
              <div class="svg-play" style="position: absolute; top: 0px; bottom: 0; left: 0; right: 0; background-image: url(/images/schedule/pbs-play-passport.svg); background-size: 100% 100%;"></div>
            </div>
          </a>
          <a target="_blank" v-else-if="is_public_full_length(air_data)" :href="`https://video.pbs12.org/video/${air_data.program_details.media_manager_data.public.asset_slug}/`">
            <div class="container"  :style="`background-image: url(${air_data.program_details.media_manager_data.public.image_url_1}); background-size: 100% 100%; position: relative; width: 100%; padding-top: 56.25%;`" >
              <div class="svg-play" style="position: absolute; top: 0px; bottom: 0; left: 0; right: 0; background-image: url(/images/schedule/pbs-play.svg); background-size: 100% 100%;"></div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- reminder form -->
    <!-- reminder form -->
    <!-- reminder form -->
    <div v-if="reminder_data != null &&
                  ( ($route.params._channel !== '-1' && $route.params._channel != -1)
                      || $route.params.exact_match === '1')" :id="suffix+'-modal-full'" class="uk-flex-top uk-modal uk-flex uk-open" uk-modal style="display: block;/*top: 78px*/;z-index: 10000;">
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical" style="padding-top: 30px;min-width: 70%;z-index: 2100;">
        <button @click="reminder_data = null" class="uk-modal-close-full uk-close-large uk-icon uk-close" style="position: sticky;top: 10px;float: right;margin-right: -20px;margin-top: -25px;" type="button" uk-close="">
          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="close-large">
            <line fill="none" stroke="#000" stroke-width="1.4" x1="1" y1="1" x2="19" y2="19"></line><line fill="none" stroke="#000" stroke-width="1.4" x1="19" y1="1" x2="1" y2="19"></line>
          </svg>
        </button>
        <div class="uk-grid-collapse uk-child-width-1-2@s uk-flex-top uk-grid" style="" uk-grid>
          <ProgramReminderForm v-bind:program_details="reminder_data" />
        </div>
      </div>
    </div>
    <div v-else-if="reminder_data != null" style="margin-top: 20px;">
      <div class="uk-grid-collapse uk-child-width-1-2@s uk-flex-top uk-grid" style="" uk-grid>
        <ProgramReminderForm v-bind:program_details="reminder_data" />
      </div>
    </div>
  </div>
</template>

<script>

import ProgramReminderForm from "./ProgramReminderForm"
import $ from "jquery"
import uk from 'uikit'

export default {
    name: "ProgramDetails",
    components: {ProgramReminderForm},
    props:['air_data','open_passport','suffix'],
    data(){
        return {
            base_url: 'https://www.pbs12.org/',
            reminder_data: null,
            load_passport: false
        }
    },
    methods:{
        details_description(program_details){
            if(program_details.episode_desc.length > 1 &&  program_details.episode_desc !== program_details.series_desc) return program_details.episode_desc
            return program_details.series_desc
        },
        to_all_airdates(air_data){
            let title = air_data.series_title
            let vm = this
            console.log('to all airdates: ', air_data)
            console.log('to all airdates: ', title)
            console.log('current params: ', vm.$route.params)
            // let channel = (vm.$route.params._channel != undefined) ? vm.$route.params._channel:'1'
            let type = (vm.$route.params.type != undefined) ? vm.$route.params.type:'1'
            let genres_list = (air_data.program_details.genre_list == undefined || air_data.program_details.genre_list == null || air_data.program_details.genre_list === '') ? 'none':air_data.program_details.genre_list

            console.log('to_all_airdates', { name: 'schedule', params: { 'type': type, '_channel': -1, '_current_day': title, exact_match: '1', genre_list: genres_list, _episode_id: air_data.episode_id }})
            /*
            to_all_airdates {name: 'schedule', params: {…}}name: "schedule"params: {type: 1, _channel: -1, _current_day: "Suze Orman's Ultimate Retirement Guide", exact_match: '1'}
            exact_match: "1"type: 1_channel: -1_current_day: "Suze Orman's Ultimate Retirement Guide"[[Prototype]]: Object[[Prototype]]: Object
             */
            this.$router.push({ name: 'schedule', params: { 'type': type, '_channel': -1, '_current_day': title, exact_match: '1', genre_list: genres_list, _episode_id: air_data.episode_id }})
            try {
              $('.uk-modal-close-full').click()
              uk.modal('#'+vm.suffix+'-modal-full').hide()
              for(let i=0;i<6;i++) uk.modal('#'+vm.suffix+'-modal-full-'+i).hide();
            }catch (e) {
                //
            }
            //if(air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title) title = air_data.episode_title
/*
                <div class="uk-width-5-6 pbs-schedule-grid-title" style="min-width: 290px;">{{air_data.series_title}}
                <div v-if="air_data.episode_title.length > 0 && air_data.series_title !== air_data.episode_title" class="pbs-schedule-grid-sub-title">{{air_data.episode_title}}</div>
 */
        },
        is_passport_full_length(air_data){
          return air_data.program_details.media_manager_data.passport != undefined && air_data.program_details.media_manager_data.passport != null && (air_data.program_details.media_manager_data.public === undefined || air_data.program_details.media_manager_data.public === null || air_data.program_details.media_manager_data.public.type !== 'full_length')
        },
        is_public_full_length(air_data){
          return air_data.program_details.media_manager_data.public != undefined && air_data.program_details.media_manager_data.public != null
        },
        open_passport_video(){
            this.load_passport = true
            let vm = this
            setTimeout(() => vm.reset_players_height(), 1000)
        },
        reset_players_height(){
            let _class = '.pbs-schedule-grid-title'
            if($('.uk-accordion-title').width() == undefined) _class = '.uk-modal-dialog'
            //console.log('program details width: ', $(_class).width())

            if($(_class).width() * .57 > 0) {
                setTimeout(() => {
                    let height = $(_class).width() *.9
                    if($(_class).width() > 700) height = $(_class).width()*.17
                    //console.log('program details width: ', height)
                    $('.pbs_media_manager_iframe').height(height)
                    $('.pbs_media_manager_iframe').css('margin-bottom', '20px')
                }, 2000)
            }
        },
    },
    created() {
        this.load_passport = false
        let vm = this
        setTimeout(() => vm.reset_players_height(), 1000)
        if(this.open_passport === true){
            this.open_passport_video()
        }
    },
    mounted() {
        this.load_passport = false
        let vm = this
        setTimeout(() => {
                if(this.open_passport === true){
                    this.open_passport_video()
                }
                vm.reset_players_height()
            }, 1000
        )
    }
}
</script>

<style scoped>
    .pbs-schedule-grid-time {
        color: black !important;
    }
</style>